module.exports = __webpack_public_path__ + "static/img/33.ccb1477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/33.png
// module id = VtAm
// module chunks = 1